import React, { FunctionComponent } from 'react';
import { BreadcrumbItemProps } from 'antd/lib/breadcrumb/BreadcrumbItem';
import { Breadcrumb } from 'antd';

export interface BreadcrumbItemExtendedProps extends BreadcrumbItemProps {
	children?: React.ReactNode;
	text?: string;
}

interface Props {
	items: BreadcrumbItemExtendedProps[];
	path?: string;
	separator?: React.ReactNode;
}

const BreadcrumbsWrapper: FunctionComponent<Props> = ({ items, path, separator }: Props) => {
	return (
		<div className="breadcrumbs-wrapper" data-test-id="breadcrumbs-wrapper">
			<Breadcrumb separator={separator}>
				{items
					? items.map((item, index) => {
							if (path && !path.includes(item.href)) {
								return null;
							}
							return (
								<Breadcrumb.Item
									data-test-id="breadcrumb-item"
									key={index}
									onClick={item.onClick}
									separator={item.separator}
									className={item.className}
									overlay={item.overlay}
									{...item}
								>
									{item.children} {item.text}
								</Breadcrumb.Item>
							);
					  })
					: null}
			</Breadcrumb>
		</div>
	);
};

export default BreadcrumbsWrapper;
